<template>
<div class="page-page-15481123719086096-00005ZO1 pageType-ContentPage template-pages-layout-storyPageTemplate pageLabel--contact-us language-en_IN" data-internalType="ARTICLE">
<div id="consent_blackbar"></div>
<div id="content" class="clearfix">
					<a id="skip-to-content"></a>
<div class="hidden" id="globalMessages">
			</div>

		<div id="story-page" class="whiteBg">
			<div class="container-fluid secondary-page minimizeWidth">
				<div id="content_header">
					<!-- <div class="row">
						<div class="yCmsContentSlot col-xs-12">
<div class="yCmsComponent">
<div class="simple_banner" :style="{ backgroundImage: 'url(' + bannerImage + ')' }" title="21x9-810x347-corporate-global-campus-banner-us-english-web.jpg"></div>
		</div></div></div> -->
					<div class="row">
						<div class="col-xs-12">
							<div id="breadcrumb"></div>
						</div>
					</div>
					<div class="row">
						</div>
					<div class="row">
						<div class="col-xs-12">
							<h1>Contact Us</h1>
							<hr class="top">
						</div>
					</div>
				</div>
				<div id="content_body" class="results row">
					<div class="col-xs-12">
						<div class="yCmsComponent paragraph topParagraph">
<div class="content">
	<div class="container-fluid"><div class="row"><div class="col-sm-6"><h2>Head Office</h2> <p>Modiway India Private Limited<br />Community Center,<br /> New Friends Colony,<br /> New Delhi, Pin - 110025<br /> Monday-Saturday 10:00am - 5:00pm (IST)</p> <h2>Member Services</h2> <p>For all order enquiries, commissions questions and general support.</p> <p>Monday to Saturday: 10:00am - 5:30pm (IST)<br /> Tel No: 0124-6572300<br /> Email: <a href="mailto:support@modiway.com">support@modiway.com</a></p></div> <div class="col-sm-6"><h2>Order Pick-up</h2> <p>Monday to Saturday: 10:00am - 5:00pm (IST)<br /> Order pick-up questions: <a href="http://mailto:india@modiway.com">india@modiway.com</a></p> <h2>Need More Information?</h2> <p>General service questions:&nbsp;<br /> <br /> Product Enquiries&mdash;For questions regarding product ingredients, essential oil singles, blends or other Modiway products: <a href="mailto:productsupport@modiway.com">productsupport@modicare.com</a><br /> &nbsp;</p> <p><RouterLink to="/find-wellness-advocate">Find an Advisor</RouterLink></p></div></div></div> 
	<p>&nbsp;</p>
	<iframe src="https://www.google.com/maps/embed?pb=!1m14!1m8!1m3!1d14017.015525338882!2d77.2686423!3d28.5621381!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x390ce39a3fcf1263%3A0x5174e5455e96158a!2sModicare%20Limited!5e0!3m2!1sen!2sin!4v1723533500035!5m2!1sen!2sin" height="450" style="width:100%;border:0;" allowfullscreen="" loading="lazy" referrerpolicy="no-referrer-when-downgrade"></iframe>
</div>
</div></div>
					<!-- FDA Warning slot-->
					</div>
				<div id="content_footer" class="row">
					<hr class="top"/>
					<div class="col-xs-12 col-md-6 pull-left">
    <div id="data-jspdf-print-all" data-print-all="false"></div>
    <div id="printshare_container">
        <ul class="list-inline">
            <li id="share-button" class="btn btn-share">
                <div class="dropdown">
                    <a class="" id="dropdownMenu1" data-toggle="dropdown" aria-haspopup="true" aria-expanded="true">
                        <i class="fa fa-share-alt"> </i> Share</a>
                    <ul class="dropdown-menu" id="share-dropdown" aria-labelledby="dropdownMenu1">
                        <li>
                                <a class="text-muted" id="facebook-share-link" href="#" target="_blank" >
                                    <i class="fa fa-facebook" style="margin-right: 6px;"> </i> Share on Facebook</a>
                            </li>
                            <li>
                                <a class="text-muted" href="https://twitter.com/intent/tweet?url=http://www.doterra.com" target="_blank" id="twitter-share-link" >
                                    <i class="fa fa-twitter"> </i> Tweet this</a>
                            </li>
                            <li>
                                <a class="text-muted" href="" target="_blank" id="pinterest-share-link" >
                                    <i class="fa fa-pinterest"> </i> Pin it</a>
                            </li>
                        <li>
							<div id="share_getLink">
								<i class="fa fa-link"> </i> Get Link<input type="text" value="" id="show-link" readonly="readonly"/>
							</div>
                        </li>
                        <li>
                            <a class="text-muted" id="email-message" href="#" >
                                <i class="fa fa-envelope" > </i> Email</a>
                        </li>
                    </ul>
                </div>
            </li>
            <li>
                <a class="text-dark" id="detail-image-link" href="#" target="_blank" >
                    <i class="fa fa-camera"> </i> Hi-Res Image</a>
            </li>
            <li>
                </li>
        </ul>
    </div>
</div>
</div>
			</div>
		</div>
</div>
<div id="ariaStatusMsg" class="skip" role="status" aria-relevant="text" aria-live="polite"></div>
</div>
</template>
<script>
import bannerImage from '@/assets/medias/21x9-810x347-corporate-global-campus-banner-us-english-web.jpg';
export default {
	name: 'contact-us',
	data() {
		return {
				bannerImage
			};
		}
	};
</script>
<style>
/* #content_header{margin-top:110px} */
div.secondary-page{
	text-align: left !important;
}
.simple_banner{border-radius:0px;}
.container-fluid.secondary-page.minimizeWidth{
	max-width:1400px !important;
}
.whiteBg{
	background: white !important;
}

</style>